import { gql } from '@apollo/client';

import { GraphQLTypes } from 'src/lib/graphqlTypes';

export const ServiceGraphOwnerCardFragment = gql`
  fragment ServiceGraphOwnerCardFragment on Service {
    id
    graphType
    account {
      id
      name
      capabilities {
        cloudGraphs
      }
      currentPlan {
        id
        tier
        kind
        maxRangeInDays
        name
      }
    }
  }
`;

export const UserGraphOwnerCardFragment = gql`
  fragment UserGraphOwnerCardFragment on User {
    id
    memberships {
      account {
        id
        name
        capabilities {
          cloudGraphs
        }
        currentPlan {
          id
          tier
          kind
          maxRangeInDays
          name
        }
      }
      user {
        id
      }
    }
  }
`;

export const TransferGraphOwnerMutation = gql<
  GraphQLTypes.Graph__TransferGraphOwnerMutation,
  GraphQLTypes.Graph__TransferGraphOwnerMutationVariables
>`
  mutation Graph__TransferGraphOwnerMutation(
    $serviceId: ID!
    $toAccountId: String!
  ) {
    service(id: $serviceId) {
      transfer(to: $toAccountId) {
        id
        account {
          id
        }
      }
    }
  }
`;
